<template>

  <div class="card">
    <div class="card-body">
      <p class="card-title">Upload a Excel file with the data to be imported into schema {{schema.customerId}}</p>
      <b-form-row>
        <b-col >
  <b-form-file
    v-model="currentFile"
    @change="resetDialog"
    :state="null"
    class="text-truncate"
    placeholder="choose file or drop here..."
    drop-placeholder="drop file..."
  ></b-form-file>
        </b-col>
        <b-col>
 <b-button variant="primary" :disabled="!currentFile || loading" @click="upload">
   <b-spinner v-if="loading" small></b-spinner>{{buttonLabel}}
      </b-button>
        </b-col>
      </b-form-row>
      <p v-if="loading">
           Note: Importing Data might take up to several minutes depending on the size of the file...
      </p>
      <b-row v-if="importResult && importResult.importIssues">
        <b-col>
          <b-alert class="mt-1" variant="success" :show="importResult.success" >Sucessfully imported {{ importResult.numberOfItems }} items with the following warnings:</b-alert>
          <b-alert class="mt-1"  variant="danger" :show="!importResult.success" >Import failed with the following errors and warnings:</b-alert>

          <b-table hover :items="formatedItems" :fields="fields" striped responsive="sm" class="m-2">
          </b-table>

        </b-col>
      </b-row>
    </div>
  </div>

</template>

<script>

import {BackendApiService} from '../services/BackendApiService'

export default {
  name: 'data-import',
  props: ['schema'],
  data () {
    return {
      currentFile: undefined,
      loading: false,
      importResult: {},

      fileInfos: [],
      fields: [
        {key: 'type', label: ''},
        {key: 'sheet', label: 'Sheet'},
        {key: 'row', label: 'Row'},
        {key: 'column', label: 'Column'},
        {key: 'message', label: 'Message'}
      ]
    }
  },
  computed: {
    formatedItems () {
      if (!this.importResult.importIssues) return []
      return this.importResult.importIssues.map(item => {
        item._rowVariant = item.error ? 'danger' : 'warning'
        item.type = item.error ? 'ERROR' : 'WARN'
        return item
      })
    },

    buttonLabel () {
      if (this.loading) {
        return 'Importing Data...'
      } else {
        return 'Import Data'
      }
    }
  },
  methods: {
    resetDialog () {
      this.loading = false
      this.importResult = {}
    },
    upload () {
      this.loading = true
      BackendApiService.uploadData(this.schema.id, this.currentFile, event => {
      })
        .then(response => {
          console.log('received response')
          console.log(response)
          this.importResult = response.data
          this.loading = false
          console.log('success= ' + this.importResult.success)
        })
        .catch((e) => {
          console.log('catched error ' + e)
          this.errorMessage = e.response.data.message
          this.currentFile = undefined
        })
    }
  },
  mounted () {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DataImport.vue